import { Component, Element, h, Prop, State, Watch } from '@stencil/core';
import { ActionBarConfig, YoutubeConfig } from '../../../../../interfaces';

@Component({
  tag: 'presto-action-bar',
  styleUrl: 'presto-action-bar.scss',
  shadow: true,
})
export class PrestoActionBar {
  @Element() el: HTMLElement;

  @Prop() player: any;
  @Prop() config: ActionBarConfig;
  @Prop() direction?: 'rtl';
  @Prop() youtube?: YoutubeConfig;

  @State() currentTime: number;
  @State() duration: number;
  @State() ended: boolean;

  componentWillLoad() {
    if (!this.player) return;
    this.player.on('ended', () => this.setEnded());
    this.player.on('timeupdate', e => this.setCurrentTime(e));
  }

  /** Watch for player changes on lazy load.*/
  @Watch('player')
  handlePlayerChange() {
    if (!this.player) return;
    this.player.on('ended', () => this.setEnded());
    this.player.on('timeupdate', e => this.setCurrentTime(e));
  }

  setEnded() {
    this.ended = true;
  }

  setCurrentTime(e) {
    this.currentTime = e?.detail?.plyr.currentTime;
    this.duration = e?.detail?.plyr.duration;
  }

  /**
   * Remove listeners if destroyed
   */
  disconnectedCallback() {
    if (!this.player) return;
    this.player.off('ended', this.setEnded);
    this.player.off('timeupdate', this.setCurrentTime);
  }

  render() {
    return (
      <presto-action-bar-controller
        ended={this.ended}
        config={this.config}
        currentTime={this.currentTime}
        duration={this.duration}
        direction={this.direction}
        youtube={this.youtube}
      ></presto-action-bar-controller>
    );
  }
}
